import { createApiService } from './createApiService'

// Movie recommendation interfaces
export interface MovieRecommendation {
  name: string;
  productionYear: number;
  director: string;
  imdbNumber: string;
  relationExplainer: string;
  inspirationDescription: string;
}

export interface StructuredInspirationResponse {
  recommendations: MovieRecommendation[];
}

// Simple movie inspiration interface for new format
export interface SimpleMovieInspiration {
  imdbId: string;
  explainer: string;
}

export interface SimpleInspirationResponse {
  movies: SimpleMovieInspiration[];
}

interface GenerateTextRequest {
  prompt: string;
  systemPrompt?: string;
  model?: string;
  temperature?: number;
  maxTokens?: number;
}

interface GenerateStructuredMovieRecommendationsRequest {
  prompt: string;
  systemPrompt?: string;
  model?: string;
  temperature?: number;
  maxTokens?: number;
}

interface GenerateSimpleMovieInspirationsRequest {
  prompt: string;
  systemPrompt?: string;
  model?: string;
  temperature?: number;
  maxTokens?: number;
}


export const inspirationAPI = createApiService({
  reducerPath: 'inspirationAPI',
  tagTypes: ['Inspirations'],
  endpoints: (build: any) => ({
    generateText: build.mutation({
      query: (data: GenerateTextRequest) => ({
        url: '/inspiration/generate-text',
        method: 'POST',
        body: data,
      }),
    }),
    generateStructuredMovieRecommendations: build.mutation({
      query: (data: GenerateStructuredMovieRecommendationsRequest) => ({
        url: '/inspiration/generate-structured-movies',
        method: 'POST',
        body: data,
      }),
    }),
    generateSimpleMovieInspirations: build.mutation({
      query: (data: GenerateSimpleMovieInspirationsRequest) => ({
        url: '/inspiration/generate-simple-movies',
        method: 'POST',
        body: data,
      }),
    }),
  }),
})

export const { 
  useGenerateTextMutation, 
  useGenerateStructuredMovieRecommendationsMutation,
  useGenerateSimpleMovieInspirationsMutation 
} = inspirationAPI